import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "io-faqs" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardExpand = _resolveComponent("CardExpand")!
  const _component_Observer = _resolveComponent("Observer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (faq) => {
      return (_openBlock(), _createBlock(_component_Observer, {
        key: faq.id,
        onObserveenter: ($event: any) => (_ctx.setObserved(faq.id))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CardExpand, {
            class: _normalizeClass(["io-faqs__faq", { 'observed': _ctx.observed[faq.id] }]),
            "button-type": "h3"
          }, {
            title: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: faq.title
              }, null, 8, _hoisted_2)
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: faq.content
              }, null, 8, _hoisted_3)
            ]),
            _: 2
          }, 1032, ["class"])
        ]),
        _: 2
      }, 1032, ["onObserveenter"]))
    }), 128))
  ]))
}